import { Approval, Close } from 'blaze-ui/icons'
import Styles from './ReviewRequestCard.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { StatusPill } from 'components/StatusPill/StatusPill'
import { IconButton } from 'blaze-ui/IconButton/IconButton'

interface Props {
  background?: string
  color?: string
  status?: string
  onPress?: () => void
}

export const Header = ({ background = '#ffefc5', color = '#4a3600', status, onPress }: Props) => {
  return (
    <div className={Styles.header}>
      <Text variant="label" color="var(--dark-60)">
        <span className={Styles.title}>
          <Approval color='var(--green-50)' /> Review Request
        </span>
      </Text>
      <div className={Styles.rightSide}>
        {status && (
          <StatusPill
            style={{
              background,
              color,
              fontWeight: 500,
            }}
            size="sm"
            status={status}
          />
        )}
        {onPress && (
          <IconButton aria-label="Dismiss Button" icon={Close} onPress={onPress} variant="tertiary" size="xs" />
        )}
      </div>
    </div>
  )
}
